<template>
  <div>
    <!-- <div class="cght_htmainlefttxbox">
      <div class="cght_htmainlefttx"><em></em>
        <img v-real-img="current_user.headimgurl" src="../../assets/images/touxiang02.jpg" width="108" height="108" yyzz/>
      </div>
    </div> -->
    <ul class="cght_htmainleftul">
      <li>
        <div class="cght_htmainleftult"><i class="iconfont">&#xe60a;</i>我的交易</div>
        <div class="cght_htmainleftulb">
          <em><router-link :to="{path:'/MyOrder'}" :class="leftNavi==1?'cght_htmainleftulxz':''">我的订单</router-link></em>
          <em v-if="current_user.MAccountRole===2"><router-link :to="{path:'/PreOrderList'}" :class="leftNavi==8?'cght_htmainleftulxz':''">申&#8194;购&#8194;单</router-link></em>
          <em v-if="current_user.MAccountRole===3"><router-link :to="{path:'/MyPreOrder'}" :class="leftNavi==9?'cght_htmainleftulxz':''">我的申购</router-link></em>
          <em><router-link :to="{path: '/Inquiry'}" :class="leftNavi==10?'cght_htmainleftulxz':''">询&#8194;价&#8194;单</router-link></em>
        </div>
      </li>
      <li>
        <div class="cght_htmainleftult"><i class="iconfont">&#xe609;</i>我的关注</div>
        <div class="cght_htmainleftulb">
          <em><router-link :to="{path:'/Collect'}" :class="leftNavi==3?'cght_htmainleftulxz':''">商品收藏</router-link></em>
          <em><router-link :to="{path:'/Historys'}" :class="leftNavi==4?'cght_htmainleftulxz':''">浏览历史</router-link></em>
        </div>
      </li>
      <li>
        <div class="cght_htmainleftult"><i class="iconfont">&#xe608;</i>会员资料</div>
        <div class="cght_htmainleftulb">
          <em><router-link :to="{path:'/PersonalData'}" :class="leftNavi==5?'cght_htmainleftulxz':''">个人资料</router-link></em>
          <em><router-link :to="{path:'/Address'}" :class="leftNavi==6?'cght_htmainleftulxz':''">地址管理</router-link></em>
          <em><router-link :to="{path:'/Safety'}" :class="leftNavi==7?'cght_htmainleftulxz':''">安全设置</router-link></em>
          <!-- <em><router-link :to="{path:'/'}">企业认证</router-link></em> -->
        </div>
      </li>
      <li>
        <div class="cght_htmainleftult"><i class="iconfont">&#xe616;</i>业务管理</div>
        <div class="cght_htmainleftulb">
          <em><router-link :to="{path:'/Member'}" :class="leftNavi==15?'cght_htmainleftulxz':''">数据统计</router-link></em>
          <em><router-link :to="{path:'/BusinessOrders'}" :class="leftNavi==18?'cght_htmainleftulxz':''">订单管理</router-link></em>
          <em><router-link :to="{path:'/ExpenseAccount'}" :class="leftNavi==12?'cght_htmainleftulxz':''">采购明细</router-link></em>
          <em><router-link :to="{path:'/Finance'}" :class="leftNavi==13?'cght_htmainleftulxz':''">费用列表</router-link></em>
          <em><router-link :to="{path:'/TaskDistribution'}" :class="leftNavi==17?'cght_htmainleftulxz':''">任务分配</router-link></em>
          <em><router-link :to="{path:'/TaskAllocation'}" :class="leftNavi==14?'cght_htmainleftulxz':''">任务中心</router-link></em>
          <em><router-link :to="{path: '/QuotationList'}" :class="leftNavi==11?'cght_htmainleftulxz':''">报价列表</router-link></em>
          <em><router-link :to="{path: '/Workdiary'}" :class="leftNavi==16?'cght_htmainleftulxz':''">工作日志</router-link></em>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LeftNav',
  data () {
    return {
      // leftNavi: localStorage.getItem('leftNavi')
    }
  },
  props: ['leftNavi'],
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Member/Left_nav.vue